// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__RI7xI","spin":"Spinner_spin__DSOqJ","large":"Spinner_large__9yROE","small":"Spinner_small__FXiKO"};